import { PrimeIcons } from 'primeng/api';
import { Role } from 'zenith/core';

const menu = [
  {
    label: 'Inicio',
    icon: PrimeIcons.HOME,
    routerLink: ['/app'],
  },
  {
    label: 'Administración',
    icon: PrimeIcons.BRIEFCASE,
    items: [
      {
        label: 'Perfil del condominio',
        routerLink: ['/app/condominium-profile'],
        role: [Role.ADMIN, Role.INVENTORY],
      },
      {
        label: 'Personas',
        routerLink: ['/app/person'],
        role: [Role.ADMIN, Role.INVENTORY],
      },
      {
        label: 'Proveedores',
        routerLink: ['/app/provider'],
        role: [Role.ADMIN, Role.INVENTORY],
      },
      {
        label: 'Terceros',
        routerLink: ['/app/third-party'],
        role: [Role.ADMIN, Role.ACCOUNTING],
      },
    ],
  },
  {
    label: 'Copropiedad',
    icon: PrimeIcons.BUILDING,
    items: [
      {
        label: 'Unidades',
        routerLink: ['/app/unit'],
        createLink: ['/app/unit/create'],
        role: [Role.ADMIN],
      },
      {
        label: 'Características',
        routerLink: ['/app/unit-feature'],
        role: [Role.ADMIN],
      },
      {
        label: 'Ponderación',
        routerLink: ['/app/weight'],
        createLink: ['/app/weight/create'],
        role: [Role.ADMIN],
      },
    ],
  },
  {
    label: 'Presupuesto',
    icon: PrimeIcons.WALLET,
    items: [
      {
        label: 'Presupuestos',
        routerLink: ['/app/budget'],
        createLink: ['/app/budget/create'],
        role: [Role.ADMIN, Role.BUDGET],
      },
      {
        label: 'Rubros',
        routerLink: ['/app/line-item'],
        role: [Role.ADMIN],
      },
    ],
  },
  {
    label: 'Asamblea',
    icon: PrimeIcons.USERS,
    items: [
      {
        label: 'Asambleas',
        routerLink: ['/app/assembly'],
        role: [Role.ADMIN, Role.ASSEMBLY],
      },
      {
        label: 'Orden del día',
        routerLink: ['/app/assembly-item-definition'],
        role: [Role.ADMIN, Role.ASSEMBLY],
      },
      {
        label: 'Convocatorias',
        routerLink: ['/app/assembly-notice'],
        createLink: ['/app/assembly-notice/create'],
        role: [Role.ADMIN, Role.ASSEMBLY],
      },
    ],
  },
  {
    label: 'Financiero',
    icon: PrimeIcons.CHART_LINE,
    items: [
      {
        label: 'Conceptos financieros',
        routerLink: ['/app/financial-concept'],
        role: [Role.ADMIN],
      },
      {
        label: 'Tasas de interés',
        routerLink: ['/app/financial-rate'],
        role: [Role.ADMIN],
      },
      {
        label: 'Descuentos',
        routerLink: ['/app/financial-discount'],
        role: [Role.ADMIN],
      },
    ],
  },
  {
    label: 'Inventario',
    icon: PrimeIcons.BOX,
    items: [
      {
        label: 'Activos',
        routerLink: ['/app/asset'],
        role: [Role.ADMIN, Role.INVENTORY],
      },
      {
        label: 'Ubicaciones',
        routerLink: ['/app/location'],
        role: [Role.ADMIN, Role.INVENTORY],
      },
      {
        label: 'Rondas de inspección',
        routerLink: ['/app/inspection-round'],
        createLink: ['/app/inspection-round/create'],
        role: [Role.ADMIN, Role.INVENTORY, Role.INVENTORY_INSPECTOR],
      },
    ],
  },
  {
    label: 'Contabilidad',
    icon: PrimeIcons.CALCULATOR,
    items: [
      {
        label: 'Plan de cuentas',
        icon: PrimeIcons.SITEMAP,
        routerLink: ['/app/accounting-account'],
        role: [Role.ADMIN, Role.ACCOUNTING],
      },
    ],
  },
  {
    label: 'Ayuda',
    icon: PrimeIcons.QUESTION_CIRCLE,
    items: [
      {
        label: 'Guías',
        routerLink: ['/app/guides'],
      },
      {
        label: 'Documentación API',
        url: '/docs/index.html',
        technical: ['development'],
      },
    ],
  },
];

export default menu;
